import React, { Component, createRef } from 'react';
import ReactDOM from 'react-dom';
import { CustomInput } from 'reactstrap';
import { pick } from 'lodash';
import path from 'path';
import FileBrowser, { FileRenderers } from 'react-keyed-file-browser';
import styles from './fileExplorer.module.css';

const pickProperty = object => {
  return pick(
    object,
    'id',
    'name',
    'stage_name',
    'submission_id',
    'origin_of_the_file',
    'base_url_to_display_in_file_explorer',
    'date_updated',
    'date_uploaded',
    'description',
    'download_link',
    'path',
    'isFolder',
    'size',
    'allowedActions'
  );
};

class CustomFileRenderer extends Component {
  constructor(props) {
    super(props);
    this.fileIndention = createRef()
    this.state = {
      showCheckbox: false,
      isCheckBoxChecked: false,
      width: 0,
      selectedItem: []
    };
  }

  componentWillUnmount() {
    this._isMounted = false;
  }
  toogleDisplayCheckBox = status => {
    this.setState({
      showCheckbox: status
    });
  };

  handleClick = event => {
    const data = pickProperty(this.props);
    const isChecked = event.target.checked;

    this.setState(
      {
        isCheckBoxChecked: isChecked,
        selectedItem: { ...data, isChecked }
      },
      () => {
        this.props.collectCheckedItems(this.state.selectedItem);
      }
    );
  };

  setCheckBoxPosition() {
    const dir = this.props.base_url_to_display_in_file_explorer;
    const chunks_path = dir ? dir.split('/').filter(with_val => with_val) : [];

    this.setState({
      width: chunks_path.length * 15
    });
  }

  componentDidMount() {
    this.setCheckBoxPosition();
    const id = this.props.id;
    const is_exist = this.props.checkedItems.findIndex(e => e.id === id);
    const data = pickProperty(this.props);
    const isCheckBoxChecked = is_exist > -1;
    this.setState({
      isCheckBoxChecked: isCheckBoxChecked
    });
  }

  componentDidUpdate(prevProps, prevState) {
    const id = this.props.id;

    const is_exist = this.props.checkedItems.findIndex(e => e.id === id);

    if (prevProps.checkedItems.length !== this.props.checkedItems.length) {
      const data = pickProperty(this.props);
      const isCheckBoxChecked = is_exist > -1;
      this.setState({
        isCheckBoxChecked: isCheckBoxChecked
      });
    }
    if(prevState.width !== this.state.width){
      this.fileIndention.current.style['margin-left'] = `${this.state.width}px` 
    }
  }

  toogleCheckBoxOnChange = (isCheckBoxChecked, data) => {
    this.setState(
      {
        isCheckBoxChecked: isCheckBoxChecked,
        selectedItem: { ...data, isChecked: isCheckBoxChecked }
      },
      () => {
        this.props.collectCheckedItems(this.state.selectedItem);
      }
    );
  };

  render() {
    const check_directory = path.dirname(
      this.props.base_url_to_display_in_file_explorer
    );
    const { showCheckbox, isCheckBoxChecked } = this.state;
     
    return (
      <tr
        className="p-0 m-0 w-100 border-0"
        onMouseEnter={e => {
          this.setCheckBoxPosition();
          this.toogleDisplayCheckBox(true);
        }}
        onMouseLeave={e => {
          this.toogleDisplayCheckBox(false);
        }}>
        <div
          ref={this.fileIndention}
          className={`${showCheckbox || isCheckBoxChecked ? 'visible' : 'invisible'} ${styles.cFileRDivParent}`}>
          <CustomInput
            type="checkbox"
            id={this.props.id}
            onChange={this.handleClick}
            checked={isCheckBoxChecked}
          />
        </div>
        <td colSpan="3" className="p-0 m-0 w-100 border-0">
          <div className="table-responsive">
            <table className={`p-0 m-0 w-100 border-0 table ${styles.cFileRTable}`} >
              <tbody
                className="p-0 m-0 w-100 border-0"
                onContextMenu={e => {
                  e.preventDefault();
                  const position = ReactDOM.findDOMNode(this);

                  const activeItem = pickProperty(this.props);

                  this.props.setContextMenu(
                    {
                      left: position.offsetLeft + 230,
                      top: position.offsetTop + 100
                    },
                    false,
                    activeItem
                  );
                }}>
                <FileRenderers.TableFile {...this.props} />
              </tbody>
            </table>
          </div>
        </td>
      </tr>
    );
  }
}
export default CustomFileRenderer;
